// Satu-satunya tempat kode permission RBAC ditulis di frontend ini. Mirror
// PENUH dari katalog `md_permission` (domain CLP, 68 permission) yang
// di-seed di sa-back-end -- lihat migration_rbac.sql. Kalau modul baru
// ditambah di katalog, tambahkan konstantanya di sini juga.
const PERM = {
  DASHBOARD_VIEW: 'clp.dashboard.view',

  REGISTRATIONS_VIEW: 'clp.registrations.view',
  REGISTRATIONS_UPDATE: 'clp.registrations.update',
  REGISTRATIONS_EXPORT: 'clp.registrations.export',

  BATCH_VIEW: 'clp.batch.view',
  BATCH_CREATE: 'clp.batch.create',
  BATCH_UPDATE: 'clp.batch.update',
  BATCH_DELETE: 'clp.batch.delete',

  PROGRAM_SECTIONS_VIEW: 'clp.program_sections.view',
  PROGRAM_SECTIONS_CREATE: 'clp.program_sections.create',
  PROGRAM_SECTIONS_UPDATE: 'clp.program_sections.update',
  PROGRAM_SECTIONS_DELETE: 'clp.program_sections.delete',

  PUBLICATION_VIEW: 'clp.publication.view',
  PUBLICATION_CREATE: 'clp.publication.create',
  PUBLICATION_UPDATE: 'clp.publication.update',
  PUBLICATION_DELETE: 'clp.publication.delete',

  RECOMMENDATION_VIEW: 'clp.recommendation.view',
  RECOMMENDATION_CREATE: 'clp.recommendation.create',
  RECOMMENDATION_UPDATE: 'clp.recommendation.update',
  RECOMMENDATION_APPROVE: 'clp.recommendation.approve',

  CAPACITY_BUILDING_VIEW: 'clp.capacity_building.view',
  CAPACITY_BUILDING_CREATE: 'clp.capacity_building.create',
  CAPACITY_BUILDING_UPDATE: 'clp.capacity_building.update',
  CAPACITY_BUILDING_DELETE: 'clp.capacity_building.delete',

  EVALUATION_VIEW: 'clp.evaluation.view',
  EVALUATION_CREATE: 'clp.evaluation.create',
  EVALUATION_UPDATE: 'clp.evaluation.update',
  EVALUATION_DELETE: 'clp.evaluation.delete',

  CLASSIFICATION_VIEW: 'clp.classification.view',
  CLASSIFICATION_CREATE: 'clp.classification.create',
  CLASSIFICATION_UPDATE: 'clp.classification.update',
  CLASSIFICATION_DELETE: 'clp.classification.delete',

  ATTENDANCE_VIEW: 'clp.attendance.view',
  ATTENDANCE_CREATE: 'clp.attendance.create',
  ATTENDANCE_UPDATE: 'clp.attendance.update',

  USERS_VIEW: 'clp.users.view',
  USERS_CREATE: 'clp.users.create',
  USERS_UPDATE: 'clp.users.update',
  USERS_DELETE: 'clp.users.delete',

  MENTORS_VIEW: 'clp.mentors.view',
  MENTORS_CREATE: 'clp.mentors.create',
  MENTORS_UPDATE: 'clp.mentors.update',
  MENTORS_DELETE: 'clp.mentors.delete',

  INSTITUTIONS_VIEW: 'clp.institutions.view',
  INSTITUTIONS_CREATE: 'clp.institutions.create',
  INSTITUTIONS_UPDATE: 'clp.institutions.update',
  INSTITUTIONS_DELETE: 'clp.institutions.delete',

  UNIVERSITIES_VIEW: 'clp.universities.view',
  UNIVERSITIES_CREATE: 'clp.universities.create',
  UNIVERSITIES_UPDATE: 'clp.universities.update',
  UNIVERSITIES_DELETE: 'clp.universities.delete',

  BUMDES_VIEW: 'clp.bumdes.view',
  BUMDES_CREATE: 'clp.bumdes.create',
  BUMDES_UPDATE: 'clp.bumdes.update',
  BUMDES_DELETE: 'clp.bumdes.delete',
  BUMDES_APPROVE: 'clp.bumdes.approve',

  BUMDES_PRESURVEY_VIEW: 'clp.bumdes_presurvey.view',
  BUMDES_PRESURVEY_UPDATE: 'clp.bumdes_presurvey.update',

  BUMDES_VECI_VIEW: 'clp.bumdes_veci.view',
  BUMDES_VECI_CREATE: 'clp.bumdes_veci.create',
  BUMDES_VECI_UPDATE: 'clp.bumdes_veci.update',
  BUMDES_VECI_APPROVE: 'clp.bumdes_veci.approve',

  BUMDES_LEADERSHIP_VIEW: 'clp.bumdes_leadership.view',
  BUMDES_LEADERSHIP_UPDATE: 'clp.bumdes_leadership.update',

  BUMDES_BMC_VIEW: 'clp.bumdes_bmc.view',
  BUMDES_BMC_UPDATE: 'clp.bumdes_bmc.update',
  BUMDES_BMC_APPROVE: 'clp.bumdes_bmc.approve',

  EXPORTS_EXPORT: 'clp.exports.export',
};

export default PERM;
